<template>
  <Dropdown
    :style="{width: '100%', position: 'relative'}"
    :visible="minorVisible"
    class="customDrop"
    placement="bottom-start"
    ref="minordropRef"
    trigger="custom"
  >
    <Input
      :icon="minorVisible?'ios-arrow-up':'ios-arrow-down'"
      :placeholder="placeholder"
      @on-clear="clear"
      @on-click="handleOpen"
      @on-focus="handleOpen"
      readonly
      v-model="bussinessTypeNames"
    ></Input>
    <DropdownMenu slot="list">
      <div class="treePanel">
        <div class="treeContainer">
          <Tree
            :check-strictly="true"
            :data="bussinessTypeTree"
            :multiple="multiple=='1'?true:false"
            :render="renderContent"
            @on-select-change="changeSelectNode"
            class="bussinessTypeTree"
            ref="bTypeTree"
          ></Tree>
        </div>
      </div>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
export default {
  name: 'bussinessTypeMinor',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      required: false,
      default: '请选择次业务类型'
    },
    multiple: {
      required: false,
      type: String,
      default: 1
    }
  },
  watch: {
    value: {
      handler (val) {
        this.chks = val
        this.dealTreeData()
      },
      immediate: true
    }
  },
  data () {
    return {
      minorVisible: false,
      bussinessTypeIds: [],
      bussinessTypeTree: [],
      bussinessTypeNames: '',
      current: null,
      chks: []
    }
  },
  methods: {
    changeSelectNode: function (checked, current) {
      this.current = current
      this.bussinessTypeIds = []
      const bussinessTypeList = []
      for (const idx in checked) {
        this.bussinessTypeIds.push(checked[idx].id + '')
        bussinessTypeList.push(checked[idx].name)
      }
      this.$emit('change', this.bussinessTypeIds)
      this.bussinessTypeNames = bussinessTypeList.join('，')
      this.$emit('changeSelectNode', { checked: checked.length > 0, node: current })
    },
    close: function () {
      this.minorVisible = false
      this.chks = []
      this.bussinessTypeIds = []
      this.bussinessTypeNames = ''
    },
    handleOpen: function () {
      this.minorVisible = !this.minorVisible
    },
    clear: function () {
      this.close()
    },
    minorClick (e) {
      let minordropRef = this.$refs.minordropRef.$el
      let bTypeTree = this.$refs.bTypeTree.$el
      if (!bTypeTree.contains(e.target) && !minordropRef.contains(e.target) && this.minorVisible) {
        this.minorVisible = false
      }
    },
    traverseTree: function (nodes, chkNames) {
      if (nodes === null || nodes === undefined || nodes.length === 0) return
      for (let i = 0; i < nodes.length; i++) {
        if (this.chks.includes(nodes[i].id + '')) {
          this.$set(nodes[i], 'selected', true)
          chkNames.push(nodes[i].name)
        }
        this.traverseTree(nodes[i].children, chkNames)
      }
    },
    dealTreeData: function () {
      let nameArr = []
      if (this.chks?.length > 0) {
        this.traverseTree(this.bussinessTypeTree, nameArr)
      }
      this.bussinessTypeNames = nameArr.join('，')
    },
    initBussinessTypeTree: async function () {
      let that = this
      that.bussinessTypeTree = await this.$baseData.handleData(false, that.$apis.ICHLApi.bussinessType.bussinessTypeTree, null) || []
      that.dealTreeData()
      // this.bussinessTypeTree = []
      // this.$axios.post(that.$apis.ICHLApi.bussinessType.bussinessTypeTree).then(res => {
      //   if (res.success) {
      //     that.bussinessTypeTree = res.result || []
      //     that.dealTreeData()
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error("获取业务类型失败！")
      // })
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, [
        h('span', {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }, [
          h('span', data.name)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '1.2rem'
          }
        }, [
        ])
      ])
    },
  },
  beforeMount () {
    this.chks = this.value
    this.bussinessTypeNames = ''
    this.initBussinessTypeTree()
    document.body.addEventListener('click', this.minorClick)
  },
  beforeDestroy () {
    this.close()
    document.body.removeEventListener('click', this.minorClick)
  }
}
</script>

<style scoped>
.treePanel {
  padding: 0 1rem;
  max-width: 500px;
}
</style>
